/* eslint-disable no-console */

import { register } from "register-service-worker";

if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        "App sendo servido a partir do cache pelo service worker."
      );
    },
    registered() {
      console.log("Service worker registrado.");
    },
    cached() {
      console.log("Conteúdo colocado em cache para uso offline.");
    },
    updatefound() {
      console.log("Baixando nova versão do app.");
    },
    updated() {
      console.log("Nova versão disponível. Recarregue a página para atualizar.");
      document.dispatchEvent(
        new CustomEvent("swUpdated")
      );
    },
    offline() {
      console.log("Sem conexão. Rodando em modo offline a partir do cache.");
    },
    error(error) {
      console.error("Erro ao registrar o service worker:", error);
    },
  });
}
